import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";
import { TIERS } from "@/data/content";

export default function Tesseramento({ onSelectTier }) {
  return (
    <section id="tesseramento" data-testid="tesseramento-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Tesseramento 2026/2027</span>
          <h2 className="mt-3 font-display font-extrabold uppercase tracking-tight text-3xl md:text-4xl">
            Scegli la tua tessera
          </h2>
          <p className="mt-4 text-muted-foreground font-medium">
            Diventare socio significa condividere la passione nerazzurra e usufruire di vantaggi esclusivi riservati ai soci Inter Club.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6 items-stretch">
          {TIERS.map((tier, i) => (
            <motion.div
              key={tier.id}
              data-testid="membership-tier-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`relative flex flex-col rounded-3xl border p-8 transition-all ${
                tier.popular
                  ? "border-gold bg-primary text-primary-foreground shadow-2xl md:-translate-y-3"
                  : "border-border bg-card hover:border-primary/50"
              }`}
            >
              {tier.popular && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 rounded-full bg-gold px-4 py-1 text-xs font-bold uppercase tracking-widest text-[#0B0E14]">
                  <Star size={12} fill="#0B0E14" /> Più scelto
                </span>
              )}
              <h3 className="font-display font-bold text-2xl">{tier.name}</h3>
              <p className={`text-sm font-semibold ${tier.popular ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
                {tier.kit}
              </p>
              <div className="mt-5 flex items-end gap-1">
                <span className="font-bebas text-6xl leading-none">€{tier.price}</span>
                <span className={`mb-2 text-sm font-semibold ${tier.popular ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
                  / anno
                </span>
              </div>

              <ul className="mt-6 space-y-3 flex-1">
                {tier.perks.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm font-medium">
                    <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${tier.popular ? "bg-gold text-[#0B0E14]" : "bg-primary text-primary-foreground"}`}>
                      <Check size={12} strokeWidth={3} />
                    </span>
                    {p}
                  </li>
                ))}
              </ul>

              <button
                data-testid={`membership-select-${tier.id}`}
                onClick={() => onSelectTier(tier)}
                className={`mt-8 w-full rounded-full px-5 py-3 font-bold uppercase tracking-wide transition-all ${
                  tier.popular
                    ? "bg-gold text-[#0B0E14] hover:brightness-110"
                    : "bg-primary text-primary-foreground hover:bg-primary/90"
                }`}
              >
                Iscriviti ora
              </button>
            </motion.div>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-muted-foreground">
          Upgrade <strong className="text-foreground">Plus</strong> disponibile a +€35 con gadget esclusivi del club.
        </p>
      </div>
    </section>
  );
}
